import { baseApi } from '../../../core/baseApi';
import {
  createListQuery,
  createCreateMutation,
  createUpdateMutation,
  createDeleteMutation,
} from '../../../patterns/crud';
import type { Template, CreateTemplateArgs, UpdateTemplateArgs } from '../types';

export const templatesApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    // List query
    getOrganizationTemplates: createListQuery<Template>('/templates', 'Templates')(builder),

    // Create mutation
    createTemplate: createCreateMutation<Template, CreateTemplateArgs>('/templates', 'Templates')(builder),

    // Update mutation
    updateTemplate: createUpdateMutation<Template, UpdateTemplateArgs>('/templates', 'Templates')(builder),

    // Delete mutation
    deleteTemplate: createDeleteMutation('/templates', 'Templates')(builder),
  }),
});

export const {
  useGetOrganizationTemplatesQuery,
  useCreateTemplateMutation,
  useUpdateTemplateMutation,
  useDeleteTemplateMutation,
} = templatesApi;
